module.exports = __webpack_public_path__ + "static/media/img_noble.215fc175.jpg";